module.exports = __webpack_public_path__ + "img/5.7959c8dc.png";